module.exports = __webpack_public_path__ + "img/logo_taino.d489b0a8.png";